import {ArrowsDir} from '../../../../../constants';

export const getArrowDirection = (isPrev: boolean, isVertical: boolean, isRTL: boolean) => {
  if (isVertical) {
    return isPrev ? ArrowsDir.UP : ArrowsDir.DOWN;
  }
  if (isRTL) {
    return isPrev ? ArrowsDir.RIGHT : ArrowsDir.LEFT;
  }
  return isPrev ? ArrowsDir.LEFT : ArrowsDir.RIGHT;
};
